import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, delay, ease }}
    >
      {children}
    </M>
  );
};

export const Kicker = ({ children, light = false }) => (
  <p className={`font-mono-x text-xs uppercase tracking-[0.22em] ${light ? "text-[#7ED9D2]" : "text-[#0A7189]"}`}>{children}</p>
);

export const SectionTitle = ({ children, light = false, className = "" }) => (
  <h2 className={`font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] ${light ? "text-[#FBF7EF]" : "text-[#073B4C]"} ${className}`}>
    {children}
  </h2>
);
